/**
 * The session could not be checked (the server restarting during a deploy,
 * no connection, too many requests) — which is not the same as signed out.
 * Treating it as signed out sent people to /login mid-lesson. `state` is what
 * better-auth's useSession() returns.
 */
export function sessionUnreachable(state: { data: unknown; isPending: boolean; error: unknown }): boolean {
  if (state.isPending || state.data || !state.error) return false
  return (state.error as { status?: number }).status !== 401
}
